export default __webpack_public_path__ + "img/img_ayudita-6539afa500c1ae87170fc0cf8c451946.jpeg";